import httpClient from '@utils/httpClient.js';

export function updateShopApiCall({
  id,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,
}) {
  return httpClient.put(`api/shop-blocks/${blockId}`, {
    id,

    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
  });
}
